import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-quiz-task-excel-upload',
  templateUrl: './quiz-task-excel-upload.component.html',
  styleUrls: ['./quiz-task-excel-upload.component.scss']
})
export class QuizTaskExcelUploadComponent implements OnInit {

  uploadHidden = false;
  excel_data: any;
  approvedReject: any = [];
  apiData: any;
  tableData = {
    headers: [],
    rows: [],
    keys: []
  }
  isExcelUpload: boolean = false;
  modal: any;
  subTaskId: any = "";
  localData: any;


  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private apiconfig: ApiConfiguration,
    private exportExcelService: ExportExcelService,
    private activatedRoute: ActivatedRoute,
    private xlsx: XlsxService,
    private toast: ToastClientService,
    private router: Router,
  ) {
    this.localData = JSON.parse(localStorage.getItem('engagementDetail'))
  }

  ngOnInit() {
  }

  openUploadmodel(modal) {
    this.modalService.open(modal, {
      centered: true,
      // backdrop: 'static'
    });
  }

  uploadXlsx(eve, modal) {
    this.modal = modal
    // debugger
    this.xlsx.uploadXlsx(eve).then((res: any) => {
      this.excelUpload(res.data)
    })
  }

  excelUpload(res) {
    this.tableData.headers = [];
    this.tableData.rows = [];
    this.tableData.keys = [];
    console.log(res)

    let payload = {
      // engagement_type: this.taskDetail.engagement_type,
      // task_id: this.taskId,
      engagement_type: this.localData.engagement_type_id,
      task_id: this.localData.task_id,
      mobile_numbers: res,
      whitelist_type : this.localData.whitelist_type
    }
    this.apiService.post(this.apiconfig.whiteListEngagementUser, payload).subscribe((res: any) => {
      console.log(res.body.data)

      if (res.body.data.errors.length != 0){
        this.toast.Success('File Uploaded Successfully')
        this.uploadHidden = true
        this.tableData.headers = ["Mobile Number", "Reason"]
        this.apiData = res.body.data;
        if (res.body.data.errors.length == 0) {
          this.isExcelUpload = true;
        }
        this.tableData.rows = res.body.data.errors;
        for (const [key, value] of Object.entries(this.tableData.rows[0])) {
          console.log(key, value);
          this.tableData.keys.push(key)
        }
      }else{
        this.toast.Success('File Uploaded Successfully')
        this.router.navigate(["/hubAdmin/quiz-task"])
      }
    })
  }

  downloadExcel() {
    let header = ["Mobile Number"]
    let filename = "quiz_task_templete"
    this.exportExcelService.commonPrintHeadersTwo(header, filename, 'users')
  }

  RejectedOutletExcel() {
    // common function to print rejected recoeds
    this.xlsx.export(this.tableData.rows, "rejected_list")
  }
  ngOnDestroy() {

  }
}